import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const AppSettingsCustomEventsDataApiDataTable = lazy(() =>
  import("@components/AppSettingsCustomEventsDataApiDataTable").then((module) => ({
    default: module.AppSettingsCustomEventsDataApiDataTable,
  }))
);

export const customEventsNRO: NavigationRoutingObject = {
  Component: AppSettingsCustomEventsDataApiDataTable,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("custom-user-events-menu-option", "Custom Events"),
  pageNameForTracking: () => "Custom Events",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("custom-user-events-description-nav", "Manage the user actions you track"),
  icon: "nav-system-custom-events",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
